import { CCOutstandingExpenseComingSoonModalContent } from 'features/CCOutstandingExpenseComingSoon/cc-outstanding-expense-coming-soon/CCOutstandingExpenseComingSoonModal/components/CCOutstandingExpenseCommingSoonModalContent'
import { useCCOutstandingExpenseComingSoonState } from 'features/CCOutstandingExpenseComingSoon/cc-outstanding-expense-coming-soon-routing'

export const CCOutstandingExpenseComingSoonModal = () => {
  const { state } = useCCOutstandingExpenseComingSoonState()

  if (state === null) {
    return null
  }

  return <CCOutstandingExpenseComingSoonModalContent />
}
